var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"load-content"}},[_c('div',{staticClass:"ui massive visible slow text purple loader"},[_vm._v("Loading Content")])])}]

export { render, staticRenderFns }